import * as React from 'react';
import { EventBus } from 'Workspace/EventBus';

const context = React.createContext<EventBus>(null);
export const EventBusProvider = context.Provider;
export const WithEventBus = context.Consumer;
export const useEventBus = () => React.useContext(context);
